import { inject } from 'mobx-react';
import { DatasetSearch as DapDatasetSearch } from '@dapclient/components/page/DatasetSearch';

export class DatasetSearch extends DapDatasetSearch {}

export default inject((store: any) => ({}))(DatasetSearch);
